 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_COVER from '@/components/01_Cover'
 import A2_TITLEPAGE from '@/components/02_TitlePage'
 import A3_COPYRIGHT from '@/components/03_Copyright'
 import A4_DEDICATION from '@/components/04_Dedication'
 import A5_EPIGRAPH from '@/components/05_Epigraph'
 import A6_CONTENTS from '@/components/06_Contents'
 import A7_FOREWORD from '@/components/07_Foreword'
 import A8_ACKNOWLEDGEMENT from '@/components/08_Acknowledgement'
 import A9_INTRODUCTION from '@/components/09_Introduction'
 import A0_CHAPTER01 from '@/components/10_Chapter01'
 import A1_CHAPTER02 from '@/components/11_Chapter02'
 import A2_CHAPTER03 from '@/components/12_Chapter03'
 import A3_CHAPTER04 from '@/components/13_Chapter04'
 import A4_CHAPTER05 from '@/components/14_Chapter05'
 import A5_CHAPTER06 from '@/components/15_Chapter06'
 import A6_CHAPTER07 from '@/components/16_Chapter07'
 import A7_CHAPTER08 from '@/components/17_Chapter08'
 import A8_CLOSINGWORDS from '@/components/18_ClosingWords'
 import A9_FAMILYTREE from '@/components/19_FamilyTree'
 import A0_KINSHIPTIES from '@/components/20_KinshipTies'
 import A1_TIMELINE from '@/components/21_Timeline'
 import A2_HONOURROLL from '@/components/22_HonourRoll'
 import A3_NOTES from '@/components/23_Notes'
 import A4_GLOSSARY from '@/components/24_Glossary'
 import A5_FURTHERREADING from '@/components/25_FurtherReading'
 import A6_ABOUTAUTHOR from '@/components/26_AboutAuthor'
 import EXT_DESC_FIG1 from '@/components/Ext_desc_fig1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/06_Contents",
 			"name" : "06_Contents",
 			"component" : A6_CONTENTS
 		},
 		{
 			"path" : "/07_Foreword",
 			"name" : "07_Foreword",
 			"component" : A7_FOREWORD
 		},
 		{
 			"path" : "/08_Acknowledgement",
 			"name" : "08_Acknowledgement",
 			"component" : A8_ACKNOWLEDGEMENT
 		},
 		{
 			"path" : "/09_Introduction",
 			"name" : "09_Introduction",
 			"component" : A9_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js